// extracted by mini-css-extract-plugin
module.exports = {"badge":"Streaming_badge__HMUMA","pulse":"Streaming_pulse__7viN0"};